(function($) {
	$(document).ready(function() {
		if ($('.school-material-feed-wrapper').length > 0) {
			return;
		}

		profetFilter = {
			init: function() {
				profetFilter.variables = {
					activeCategories: []
				};

				profetFilter.handleEvents();
			},

			handleEvents: function() {
				$('[data-category-filter]').on('click', function(event) {
					event.preventDefault();
					var category = $(this).attr('data-category-filter');
					if (category != 'all') {
						if (profetFilter.variables.activeCategories.includes(category)) {
							var index = profetFilter.variables.activeCategories.indexOf(category);
							if (index > -1) {
								profetFilter.variables.activeCategories.splice(index, 1);
							}
						} else {
							profetFilter.variables.activeCategories.push(category);
						}
						$('.category-filter-all').removeClass('btn-active');

						if (!profetFilter.variables.activeCategories.length) {
							$('.category-filter-all').addClass('btn-active');
						}
					} else {
						var buttons = $('.category-filter-button');
						buttons.removeClass('btn-active');
						$(this).addClass('btn-active');
						profetFilter.variables.activeCategories = [];
					}
					profetFilter.filterItems();
				});
			},

			handleButtonClick: function() {
				var buttons = $('.category-filter-button');
				buttons.each(function() {
					var category = $(this).attr('data-category-filter');
					if (category == 'all') {
						if (profetFilter.variables.activeCategories.length > 0) {
							profetFilter.variables.activeCategories = [];
						}
					}
				});
			},

			filterItems: function() {
				var items = $('[data-profet-filter-item]');
				items.show();
				items.addClass('filter-item-visible');
				items.removeClass('filter-item-hidden');
				if (profetFilter.variables.activeCategories.length == 0) {
					return;
				}
				items.each(function() {
					var category = $(this).attr('data-profet-filter-item');
					if (profetFilter.variables.activeCategories.includes(category) == false) {
						$(this).addClass('filter-item-hidden');
						$(this).removeClass('filter-item-visible');
						$(this).hide();
					}
				});
				window.setTimeout(function() {
					$('.filter-item-visible').matchHeight();
				}, 1000);
			}
		};

		profetFilter.init();
	});
})(jQuery);
